import { Pipe, PipeTransform } from '@angular/core';

/**
 * StatusPipe transforms a status value into a class for styling
 */
@Pipe({
  name: 'status',
  standalone: true
})
export class StatusPipe implements PipeTransform {
  private readonly statusClasses = new Map<string, string>([
    ['approved', 'green'],
    ['denied', 'red'],
    ['declined', 'red'],
    ['rejected', 'red'],
    ['pending', 'purple'],
    ['awaiting', 'purple'],
    ['open', 'green'],
    ['active', 'green'],
    ['funded', 'green'],
    ['paid', 'green'],
  ]);

  transform(value: unknown, ...args: unknown[]): unknown {
    // If the value is not a string, return the value
    if (typeof value !== 'string') {
      return value;
    }

    const color = this.statusClasses.get(value.toLowerCase()) || 'grey';

    // Convert the status value to a class for styling
    return `status-field status-${color}`;
  }

}
